import { render, staticRenderFns } from "./short_video_task_list.vue?vue&type=template&id=de164c7e"
import script from "./short_video_task_list.vue?vue&type=script&lang=js"
export * from "./short_video_task_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports